import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import {List, Pagination, Empty} from 'antd';
import styles from './PaginationList.module.css';
import request from "../../utils/NetWorkUtil";
import responseMessage from "../../utils/ResponseMessage";

const getListDataRequest = async (url, params, option = {}) => {
    return request(url, {
        method: 'GET',
        params,
        ...option
    });
};

const PaginationList = (props) => {
    const {
        title = '',
        titleStyle = {},
        renderItem,
        url,
        requestOption = {},
        onGetDataFinish = async (data) => {
            return data;
        },
        hidePagination = false,
        showSize,
        renderListHeader,
        style = {},
    } = props;

    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [data, setData] = useState([]);
    const [rawData, setRawData] = useState([]);
    const [total, setTotal] = useState(0);
    const [onLoading, setOnLoading] = useState(true);

    useEffect(() => {
        (async () => {
            await handleGetListDataEvent(1);
        })();
    }, [url]);

    const handleGetListDataEvent = async (newPage) => {
        const params = {page: newPage, size};
        const { data, status, message } = await getListDataRequest(url, params, requestOption);
        if (status) {
            const processedData = await handleData(data);
            setTotal(processedData.count);
            setData(processedData.list);
            setSize(processedData.size);
            setPage(newPage);
            setOnLoading(false);
        } else {
            responseMessage.error(`查询失败，${message}`)
        }
    };

    const handleData = async (data) => {
        if (data && data.list) {
            setRawData(data.list);
            return await onGetDataFinish(data)
        } else if (data instanceof Array) {
            setRawData(data);
            return onGetDataFinish({list: data, count: data.length, page: 1, size: data.length})
        } else {
            responseMessage.error(`数据异常`);
            setRawData([]);
            return onGetDataFinish({list: [], count: 0, page: 1, size: 0})
        }
    };

    return (
        <div className={styles.wrapper} style={style}>
            {title && <div className={styles.title} style={titleStyle}>{title}</div>}
            {renderListHeader && renderListHeader(data, rawData)}
            <List
                itemLayout="horizontal"
                loading={onLoading}
                dataSource={data}
                renderItem={(data) => renderItem(data, rawData)}
            />
            {
                hidePagination
                ?   null
                :   <Pagination
                        style={{marginBottom: 16}}
                        current={page}
                        pageSize={size}
                        total={total}
                        onChange={async (page, pageSize) => {
                            await handleGetListDataEvent(page);
                            window.scrollTo(0,300);
                        }}
                    />
            }

        </div>
    );
};

export default connect()(PaginationList);
